angular.module('mercury.modules.reports.discounts')
.config(["$stateProvider", function($stateProvider) {
  $stateProvider.state('Reports.DiscountsOverview', {
    url: '/discounts?report',
    templateUrl: 'modules/reports/discounts/overview.tpl.html',
    controller: 'ReportsDiscountsOverviewCtrl'
  });
  $stateProvider.state('Reports.DiscountTimes', {
    url: '/times?report',
    templateUrl: 'modules/reports/discounts/times.tpl.html',
    controller: 'ReportsDiscountTimesCtrl'
  });
  $stateProvider.state('Reports.DiscountsTypes', {
    url: '/types?report',
    templateUrl: 'modules/reports/discounts/types.tpl.html',
    controller: 'ReportsDiscountTypesCtrl'
  });
  $stateProvider.state('Reports.SurchargesTimes', {
    url: '/surchargesTimes?report',
    templateUrl: 'modules/reports/discounts/surchargeTimes.tpl.html',
    controller: 'ReportsSurchargeTimesCtrl'
  });
  $stateProvider.state('Reports.SurchargesTypes', {
    url: '/surchargesTypes?report',
    templateUrl: 'modules/reports/discounts/surchargeTypes.tpl.html',
    controller: 'ReportsSurchargeTypesCtrl'
  });
}]);
